import React from 'react'
import Card from 'react-bootstrap/Card';
import SvgCharla from './Remark.gif';

export default function Nosotros() {
  return (
    <section
      className="px-2 py-4 text-center items-center justify-center bg-light"
      style={{
        minHeight: '50vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}
    >
      <Card
        style={{
          display: 'flex',
          flexDirection: 'row',
          width: '85%',
          padding: '18px',
          borderRadius: '32px'
        }}
        className="flex-column flex-md-row"
      >
        <div
          className="d-flex justify-content-center align-items-center mb-3 mb-md-0"
          style={{ width: '100%' }}
        >
          <Card.Img
            className="text-center"
            variant="top"
            src={SvgCharla}
            style={{
              objectFit: 'cover',
              width: '160px',
              height: '160px'
            }}
          />
        </div>
        <Card.Body>
          <Card.Title className="fw-bolder text-body-secondary">
            Sobre Nosotros
          </Card.Title>
          <Card.Text className="text-body-tertiary">
            Somos una empresa especializada en remodelaciones, plomería y electricidad. 
            Brindamos servicios tanto a clientes particulares
            como a administraciones de consorcio, asegurando calidad y seguridad en
            cada proyecto. Nuestro equipo de profesionales altamente capacitados
            garantiza soluciones eficientes y personalizadas para cada necesidad.
          </Card.Text>
        </Card.Body>
      </Card>
    </section>
  )
}
